import { LOADING, USER } from "../actionType/socialAuthType";

const initialState = {
  user: null,
  loading: false,
};

const socialAuthReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER:
      return { ...state, user: payload };
    case LOADING:
      return { ...state, loading: payload };
    default:
      return state;
  }
};

export default socialAuthReducer;
